<template>
  <div class="act-enter">
    <div class="main-con" :style="{ 'background-color': imgShow ? '' : '#fafafa' }">
      <img v-if="imgShow" class="main-img" :src="imgUrl | imgPath" @error="handleError" />

      <div class="bottom-con">
        <!-- prettier-ignore -->
        <div v-if="type === 'plus'" class="discount">
          +{{ discount }}<i>%</i>
        </div>
        <!-- prettier-ignore -->
        <div v-if="type === 'off'" class="discount">
          {{ discount }}<i>%</i>
          <i v-if="$i18n.locale == 'ar'">خصم</i>
          <i v-else>OFF</i>
        </div>
        <div v-if="timeShow && countdownResult" class="dead-line" :style="{ color: timeColor }">
          {{ countdownResult.hours }}:{{ countdownResult.minutes }}:{{ countdownResult.seconds }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import countDown from '@/mixin/count-down.js'

export default {
  name: 'act-enter',
  mixins: [countDown],
  data() {
    return {
      imgShow: true,
      type: '',
      imgUrl: '',
      discount: 0,
      timeShow: false,
      timeColor: ''
    }
  },
  methods: {
    handleError() {
      this.imgShow = false
    }
  },
  created() {
    // img: 'public/app/activity/repurchase_999_wheel_icon.png'
    // ty: 'plus'     plus/off
    // dis: '40%'
    // time: 'true'
    // expireTimeMills: '1762915863081'
    // timeColor: '000000'

    try {
      if (this.$route.query.ty) {
        this.type = this.$route.query.ty
      }
      if (this.$route.query.img) {
        this.imgUrl = this.$route.query.img
      }
      if (this.$route.query.dis) {
        this.discount = this.$route.query.dis.replace('%', '')
      }

      this.timeShow = this.$route.query.time === 'true'
      if (this.timeShow) {
        const endTime = this.$route.query.expireTimeMills ? this.$route.query.expireTimeMills * 1 : 0
        const remainTime = (endTime - Date.now()) / 1000
        this.initCountDown(remainTime, false)

        if (this.$route.query.timeColor) {
          this.timeColor = `#${this.$route.query.timeColor}`
        }
      }
    } catch (err) {
      console.log('try catch err:', err)
    }
  },
  mounted() {
    document.body.style.backgroundColor = 'transparent'
  },
  beforeDestroy() {
    document.body.style.backgroundColor = '#ffffff'
  }
}
</script>

<style lang="scss" scoped>
.act-enter {
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  .main-con {
    width: 80px;
    height: 100px;
    position: relative;

    .main-img {
      width: 100%;
    }

    .bottom-con {
      position: absolute;
      bottom: 0;
      left: 0;
      z-index: 999;
      width: 100%;

      .discount {
        color: #fffcff;
        text-align: center;
        font-family: 'TikTok Sans';
        font-size: 17px;
        font-style: italic;
        font-weight: bold;
        line-height: 28px;
        i {
          color: #fffcff;
          font-family: 'TikTok Sans';
          font-size: 12px;
          font-style: italic;
          line-height: normal;
        }
      }

      .dead-line {
        text-align: center;
        font-family: 'TikTok Sans';
        font-size: 12px;
        font-style: normal;
        font-weight: 500;
        line-height: 18px;

        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
}
</style>
